import { CartService, CartServiceModule } from '@b2b/common/services';
import { AddressService, AddressServiceModule } from '@b2b/common/services/address';
import { getFullName } from '@b2b/common/services/helpers';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IQService, IScope } from 'angular';
import { OrgSearchDirectiveModule } from '../../orgSearch/orgSearch';

interface OrderOrganization {
  organizationId: number;
  organizationName: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  city: string;
  state: string;
  category: string;
  reseller: string;
  id: number;
  name: string;
}

OrderOrganizationDirective.$inject = ['$state', 'AddressService', 'ApiService', 'HelpersService', 'CartService'];

function OrderOrganizationDirective(
  $state: StateService,
  AddressService: AddressService,
  ApiService: ApiService,
  HelpersService: TODO,
  CartService: CartService,
) {
  OrderOrganizationController.$inject = ['$scope', '$q', '$uibModal'];

  function OrderOrganizationController(
    $scope: IScope & { orderOrganization: TODO },
    $q: IQService,
    $uibModal: UIBModalService,
  ) {
    const ctrl = {
      model: {} as TODO,
      selectedOrganization: null as OrderOrganization | null,
      organizationsList: [] as TODO[],

      init: function () {
        ctrl.setModel();
        $scope.$on('$destroy', $scope.$watch('orderOrganization.selectedOrganization', ctrl.onOrganizationChange));
      },

      setModel: function () {
        ctrl.model = CartService.getOrganization() || {};

        if (ctrl.model && ctrl.model.id) {
          ctrl.model.address = AddressService.createAddress(ctrl.model);
          ctrl.selectedOrganization = ctrl.model;
        }
      },

      resetSelection: function () {
        if (ctrl.model.id) {
          ctrl.selectedOrganization = ctrl.organizationsList[0];
        } else {
          ctrl.organizationsList = [];
          ctrl.selectedOrganization = null;
          CartService.updateOrganization(null);
          CartService.cancelCart();
        }
      },

      updateOrganization: function () {
        const showPrompt = !HelpersService.isEmptyObject(ctrl.model) && !ctrl.selectedOrganization;

        if (!showPrompt) {
          ctrl.updateOrganizationAndProceed();
          return;
        }

        const fullName = getFullName(ctrl.model);

        ctrl
          .showMessage({
            title: 'Are you sure?',
            message: `Do you want to remove ${fullName} from the order?<br><br>Doing so will remove any items in the cart.`,
            okText: 'Continue',
          })
          .then(() => {
            ctrl.model = {};
            ctrl.resetSelection();
          })
          .catch(() => {
            if (ctrl.model) {
              ctrl.selectedOrganization = ctrl.model;
            } else if (!ctrl.selectedOrganization) {
              ctrl.resetSelection();
            }
          });
      },

      updateOrganizationAndProceed: function () {
        if (!ctrl.selectedOrganization && !HelpersService.isEmptyObject(ctrl.model)) {
          ctrl.resetSelection();
        } else {
          CartService.updateOrganization(ctrl.selectedOrganization);
          ctrl.setModel();
        }
      },

      showMessage: function (props: { title: string; message?: string; okText?: string }) {
        if (!props.message) {
          return $q.when(false);
        }

        return $uibModal.open({
          size: 'md',
          controller: 'ConfirmModalController',
          templateUrl: 'common/views/modals/confirm/confirm.tpl.html',
          resolve: {
            modalTitle: () => props.title,
            modalMessage: () => props.message,
            okText: () => props.okText || 'Done',
            cancelText: () => null,
          },
        }).result;
      },

      onOrganizationChange: function (e, data) {
        ctrl.updateOrganization();
      },
    };

    $scope.orderOrganization = ctrl;
    ctrl.init();
  }

  return {
    restrict: 'A',
    replace: true,
    templateUrl: 'common/directives/order/organization/organization.tpl.html',
    scope: {},

    link: function ($scope, $element, $attrs, ngModelCtrl) {},

    controller: OrderOrganizationController,
  };
}

export const OrderOrganizationDirectiveModule = angular
  .module('acme.common.directive.order.organization', [
    AddressServiceModule,
    'acme.common.service.api',
    'acme.common.service.helpers',
    CartServiceModule,
    OrgSearchDirectiveModule,
    'ui.bootstrap',
  ])
  .directive('organization', OrderOrganizationDirective).name;
